export enum AdminSettingsSection {
	Cards = 'Cards',
	Company = 'Company',
	BrandSettings = 'BrandSettings',
	GoogleReviewBrandingPreferences = 'GoogleReviewBrandingPreferences',
	AICustomContent = 'AICustomContent',
	Defaults = 'Defaults',
	Meetings = 'Meetings',
	Blog = 'Blog',
	UsersAndBilling = 'UsersAndBilling',
	UserGroups = 'UserGroups',
	ReceivePayments = 'ReceivePayments',
	SocialMedia = 'SocialMedia',
}

export const SOCIAL_MEDIA_DISCLAIMER_MAX_CHARS = 1500;
